import { createQueryKeys } from '@lukemorales/query-key-factory';
import { useMutation, useQuery, UseQueryOptions } from '@tanstack/react-query';
import { ProductApi } from 'api';
import type { Product } from 'api/methods/ProductApi';

/**
 * [product] Query Key 생성
 * --
 */
export const productsQueryKeys = createQueryKeys('product', {
  getProduct: (idx: number, params?: { [key: string]: string | number }) => [
    idx,
    params,
  ],
  getProducts: (params?: { [key: string]: string | number }) => [params],
  getProductList: (params?: { [key: string]: string | number }) => [params],
});

/**
 * [product] 상품 전체 조회
 * --
 */
export const useGetProducts = (
  params?: { [key: string]: string | number },
  options?: UseQueryOptions<any, any>
) => {
  const data = useQuery({
    queryKey: productsQueryKeys.getProducts(params).queryKey,
    queryFn: () => ProductApi.getProducts(params),
    ...options,
  });

  return data;
};

/**
 * [product] 상품 상세 조회
 * --
 */
export const useGetProduct = (
  idx: number,
  params?: { [key: string]: string | number },
  options?: UseQueryOptions<any, any>
) => {
  const data = useQuery({
    queryKey: productsQueryKeys.getProduct(idx, params).queryKey,
    queryFn: () => ProductApi.getProduct(idx, params),
    ...options,
  });

  return data;
};

/**
 * [product] 상품 추가
 * --
 */
export const useCreateProduct = (body: Product) => {
  const { mutateAsync: createProduct, ...result } = useMutation({
    mutationFn: (variables: Product) => ProductApi.createProduct(variables),
    onSuccess: (data, variables) => {
      console.log(data, variables);
    },
    onError: (error) => {
      console.log(error);
    },
  });

  return { createProduct, ...result };
};

/**
 * [product] 상품 수정
 * --
 */
export const useUpdateProduct = () => {
  const { mutateAsync: updateProduct, ...result } = useMutation({
    mutationFn: (variables: Product) => ProductApi.updateProduct(variables),
    onSuccess: (data, variables) => {
      console.log(data, variables);
    },
    onError: (error) => {
      console.log(error);
    },
  });

  return { updateProduct, ...result };
};

/**
 * [product] 상품 삭제
 * --
 */
export const useDeleteProduct = () => {
  const { mutateAsync: deleteProduct, ...result } = useMutation({
    mutationFn: (variables: number) => ProductApi.deleteProduct(variables),
    onSuccess: (data, variables) => {
      console.log(data, variables);
    },
    onError: (error) => {
      console.log(error);
    },
  });

  return { deleteProduct, ...result };
};

/**
 * [product] 상품 전체 조회
 * --
 */
export const useGetProductList = (
  params?: { [key: string]: string | number },
  options?: UseQueryOptions<any, any>
) => {
  const data = useQuery({
    queryKey: productsQueryKeys.getProductList(params).queryKey,
    queryFn: () => ProductApi.getProductList(params),
    ...options,
  });

  return data;
};

/**
 * [product] 상품 수정
 * --
 */
export const useUpsertProduct = () => {
  const { mutateAsync: upsertProduct, ...result } = useMutation({
    mutationFn: (variables: Product[]) => ProductApi.upsertProduct(variables),
  });

  return { upsertProduct, ...result };
};
